import React from "react";
import { Router } from "@reach/router";
import DefaultLayout from "../layouts/index";
import Route from "../components/common/route/route";
import LoginContainer from "../containers/login";

const Index = () => {
  return (
    <DefaultLayout>
      <Router>
        <Route path="/" component={LoginContainer} default={true} />
      </Router>
    </DefaultLayout>
  );
};

export default Index;
